'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import UICheckbox from 'UIComponents/input/UICheckbox';
import Small from 'UIComponents/elements/Small';
import { callIfPossible } from 'UIComponents/core/Functions';
import { EditableLegalConsentKeys } from 'FormsCommonComponents/constants/LegalConsent';
import LegalConsent, { getEditableLegalConsentKeysForLegalConsentType } from 'FormsCommonComponents/lib/LegalConsent';
import isEmpty from 'hs-lodash/isEmpty';
import * as HtmlSanitizer from 'sanitize-text/sanitizers/HtmlSanitizer';

var LegalConsentFields = /*#__PURE__*/function (_Component) {
  _inherits(LegalConsentFields, _Component);

  _createClass(LegalConsentFields, null, [{
    key: "propTypes",
    get: function get() {
      return {
        legalConsentRecord: PropTypes.instanceOf(LegalConsent).isRequired,
        communicationConsentCheckedState: PropTypes.array,
        onCommunicationCheckboxChange: PropTypes.func
      };
    }
  }]);

  function LegalConsentFields() {
    var _this;

    _classCallCheck(this, LegalConsentFields);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LegalConsentFields).call(this));
    _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LegalConsentFields, [{
    key: "handleCheckboxChange",
    value: function handleCheckboxChange(checkbox, checked, isCommunicationConsent) {
      var onCommunicationCheckboxChange = this.props.onCommunicationCheckboxChange;

      if (!isCommunicationConsent) {
        return;
      }

      callIfPossible(onCommunicationCheckboxChange, checkbox, checked);
    }
  }, {
    key: "renderHelpText",
    value: function renderHelpText(helpText) {
      if (!helpText) {
        return null;
      }

      return /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: HtmlSanitizer.formatHtml(helpText)
          }
        })
      });
    }
  }, {
    key: "renderCheckbox",
    value: function renderCheckbox(name, label, helpText) {
      var _this2 = this;

      var isCommunicationConsent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var checkbox = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var communicationConsentCheckedState = this.props.communicationConsentCheckedState;
      var isChecked = false;

      if (isCommunicationConsent) {
        var currentCheckbox = (communicationConsentCheckedState || []).find(function (item) {
          return item.communicationTypeId === checkbox.communicationTypeId;
        });

        if (!isEmpty(currentCheckbox)) {
          isChecked = currentCheckbox.consented;
        }
      }

      var requiredStyle = {
        color: 'red',
        'padding-left': '4px'
      };
      return /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs(UICheckbox, {
          type: "checkbox",
          name: name,
          size: "small",
          defaultChecked: isChecked,
          onChange: function onChange(_ref) {
            var checked = _ref.target.checked;
            return _this2.handleCheckboxChange(checkbox, checked, isCommunicationConsent);
          },
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              display: 'flex'
            },
            children: [/*#__PURE__*/_jsx("span", {
              dangerouslySetInnerHTML: {
                __html: HtmlSanitizer.formatHtml(label)
              }
            }), checkbox.required ? /*#__PURE__*/_jsx("span", {
              style: requiredStyle,
              children: "*"
            }) : null]
          }), this.renderHelpText(helpText)]
        })
      }, name);
    }
  }, {
    key: "renderText",
    value: function renderText(name, text) {
      return /*#__PURE__*/_jsx("p", {
        dangerouslySetInnerHTML: {
          __html: HtmlSanitizer.formatHtml(text)
        }
      }, name);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var legalConsentRecord = this.props.legalConsentRecord;
      return /*#__PURE__*/_jsx("div", {
        className: "legal-consent-container",
        children: Object.values(getEditableLegalConsentKeysForLegalConsentType(legalConsentRecord.getLegalConsentType()) || {}).map(function (key) {
          switch (key) {
            case EditableLegalConsentKeys.COMMUNICATION_CONSENT_TEXT:
            case EditableLegalConsentKeys.PROCESSING_CONSENT_TEXT:
            case EditableLegalConsentKeys.PRIVACY_POLICY_TEXT:
              return _this3.renderText(key, legalConsentRecord.get(key));

            case EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES:
              return legalConsentRecord.get(key).map(function (checkbox) {
                return _this3.renderCheckbox("LEGAL_CONSENT.subscription_type_" + checkbox.communicationTypeId, checkbox.label, null, true, checkbox);
              });

            case EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL:
              return _this3.renderCheckbox(key, legalConsentRecord.get(key), legalConsentRecord.get(EditableLegalConsentKeys.PROCESSING_CONSENT_FOOTER_TEXT), false, {
                required: true
              });

            default:
              return null;
          }
        })
      });
    }
  }]);

  return LegalConsentFields;
}(Component);

export { LegalConsentFields as default };